import { Injectable } from '@angular/core';
import { UtService } from "../../../core/service/Base.Service";
import { GenEnum } from "../../shared/general.enum";

@Injectable()
export class MenusService extends UtService<any>{

    constructor() {
        super('utmenu');
    }

    async GetMenus(appcode) {
        const rslt = await this.get('MenusV2', appcode);
        return rslt.Data;
    }
    async getParentMenuItems(menuhdrid: number, menucatid?: number) {
        const result = this.get('ParentMenuItems', [menuhdrid, menucatid]);
        return result
    }

    async getMenuItems(menuhdrid: number, parentid: number) {
        const result = this.get('MenuItems', [menuhdrid, parentid]);
        return result
    }

    async getMenu() {
        const result = this.get('menu', ['null', GenEnum.Menucategory.Screens]);
        return result
    }


    async getAdminUserRight(parentid: any, menucatid: Number, appid: Number, dbid: Number) {
        const result = this.get('AdminUserRight', [parentid, menucatid, appid, dbid]);
        return result
    }
}






// WEBPACK FOOTER //
// ./src/app/shell/forms/utmenus/utmenus.service.ts